<template>
  <div class="mb-4">
    <div>
      <h5>
        {{
          "request_sent_wait_status_pay"
            | setText("Заявка отправлена, ожидание статуса оплаты")
        }}
      </h5>
      <button class="btn btn-info btn-icon mw mt-4 mb-5" @click="sendRequest">
        {{ "check_status_paid" | setText("Проверить статус оплаты") }}
      </button>
      <h5>{{ "payment_methods" | setText("Методы оплат") }}:</h5>
      <select class="form-control" @change="pay" v-model="payment">
        <option :value="null">{{ "select" | setText("Выберите") }}</option>
        <option :value="currentRequest.response.payme_url">PAYME</option>
        <option :value="currentRequest.response.click_url">CLICK</option>
      </select>

      <modal
        :scrollable="true"
        :height="'auto'"
        :width="400"
        :adaptive="true"
        name="pay-apex"
        @before-close="modalClose"
      >
        <card>
          <div class="text-center">
            <qrcode-vue :value="payment" :size="180" level="H"></qrcode-vue>
            <a target="_blank" :href="payment">{{
              "open_link_payment" | setText("Перейти по ссылке на оплату")
            }}</a>
            <hr />

            {{
              "copy_link_payment"
                | setText("Скопируйте ссылку и отправьте клиенту")
            }}

            <small class="link">
              {{ payment }}
            </small>
            <div>
              <button
                @click="$modal.hide('pay-apex')"
                class="btn btn-danger mt-4"
              >
                {{ "cancel" | setText("Отмена") }}
              </button>
            </div>
          </div>
        </card>
      </modal>
    </div>
  </div>
</template>
<script>
import {
  logger,
  errorNotify,
  toFormData,
  dateConvert,
  addMonth,
} from "@/plugins/functions";
import QrcodeVue from "qrcode.vue";
export default {
  components: {
    QrcodeVue,
  },
  methods: {
    modalClose() {
      this.payment = null;
    },
    pay(e) {
      this.payment = e.target.value;
    },
    async sendRequest() {
      this.$loading(true);
      const url = `${this.currentRequest.service.api_endpoint_url}policy`;
      const method = "post";
      const headers = {
        Authorization:
          "Basic " +
          btoa(
            this.currentRequest.service.api_login +
              ":" +
              this.currentRequest.service.api_password
          ),
      };
      //DATA
      let data = {
        user_id: this.user_id,
        contract_id: this.data.exchange_id,
      };
      //REQUEST
      return this.$http({
        method: method,
        data: data,
        url: url,
        headers: headers,
      })
        .then((response) => {
          const responseData = response.data;

          if (responseData) {
            switch (responseData.result) {
              case 0:
                this.$emit("input", {
                  service_request: {
                    state: "confirm",
                    service: "apex",
                    exchange_id: responseData.contract_id,
                    response: JSON.stringify(responseData),
                    body: JSON.stringify(data),
                  },
                });
                break;

              default:
                break;
            }

            if (responseData.result_message) {
              this.$notify({
                title: "APEX",
                message: responseData.result_message,
                icon: "ti-info",
                horizontalAlign: "right",
                verticalAlign: "top",
              });
            }
          }
          return responseData;
        })
        .catch((error) => {
          return errorNotify(error, this.notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  props: ["value", "data", "currentRequest", "user_id"],
  watch: {
    payment(val) {
      if (val) {
        this.$modal.show("pay-apex");
      } else {
        this.$modal.hide("pay-apex");
      }
    },
  },
  data() {
    return {
      payment: null,
    };
  },
};
</script>

 